// extracted by mini-css-extract-plugin
export default {"projectDescription":"ProjectMainView_projectDescription__f2ARI","contentView":"ProjectMainView_contentView__XQXjc","readmore":"ProjectMainView_readmore__84OSG"};